import { Pagination } from '../../../../../../models/pagination-table.model';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TableOptions } from '../../../../../../services/i-bary-table-fetch-service';
import { IAcceptance } from '../../../../../../models/acceptance.model';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { SortDirective } from '../../../../../../directives/sort.directive';
import { SortByDirective } from '../../../../../../directives/sort-by.directive';
import { TranslateDirective } from '../../../../../../directives/translate.directive';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgForOf } from '@angular/common';

@Component({
  selector: 'jhi-acceptances-list',
  templateUrl: './acceptances-list.component.html',
  styleUrls: ['./acceptances-list.component.scss'],
  standalone: true,
  imports: [MDBBootstrapModulesPro, SortDirective, SortByDirective, TranslateDirective, FontAwesomeModule, NgForOf],
})
export class AcceptancesListComponent {
  @Input() acceptances?: IAcceptance[];
  @Input() tableOptions?: TableOptions;
  @Input() pagination!: Pagination;
  @Output() paginationChange = new EventEmitter<Pagination>();

  transition(): void {
    this.paginationChange.emit(this.pagination);
  }

  trackId(index: number, item: IAcceptance): number {
    return item.id!;
  }
}
